<template>
    <div>
        <form-wrapper class="billing-form">
            <form-row align="bottom">
                <form-cell v-if="!isAlreadySubscribed" width="two-thirds">
                    <common-page-header
                        :heading="'Your billing information'"
                        size="page-plain-header"
                        contentSpacing="medium"
                        :isCenter="false"
                    ></common-page-header>
                </form-cell>
                <form-cell v-if="!isAlreadySubscribed" width="third">
                    <p v-if="isAnnual" class="billing-form--info">
                        <span>${{ yearlyPrice }}</span>
                        {{ $t('pages.billing.billing.billing_form.year') }}
                    </p>
                    <p v-else class="billing-form--info">
                        <span>${{ monthlyPrice }}</span>
                        {{ $t('pages.billing.billing.billing_form.month') }}
                    </p>
                </form-cell>
            </form-row>
            <form-row>
                <form-cell>
                    <stripe-component
                        ref="stripeComponent"
                        @payment-details-failed="paymentDetailsFailed"
                        @payment-details-saved="createSubscription"
                        @stripe-loaded="stripeLoaded"
                    ></stripe-component>
                </form-cell>
            </form-row>
            <form-row v-if="!isAlreadySubscribed">
                <common-page-header
                    :heading="$t('pages.billing.billing.billing_form.billing_address')"
                    size="page-plain-header"
                    contentSpacing="medium"
                    :isCenter="false"
                ></common-page-header>
            </form-row>
            <form-row v-if="!isAlreadySubscribed">
                <form-cell width="half">
                    <text-field
                        :placeholder="$t('pages.billing.billing.billing_form.street')"
                        :isRequired="false"
                        :formData="data"
                        valuePath="address"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
                <form-cell v-if="!isAlreadySubscribed" width="half">
                    <text-field
                        :placeholder="$t('pages.billing.billing.billing_form.city')"
                        :isRequired="false"
                        :formData="data"
                        valuePath="city"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>
            <form-row v-if="!isAlreadySubscribed">
                <form-cell width="half">
                    <text-field
                        :placeholder="$t('pages.billing.billing.billing_form.state')"
                        :isRequired="false"
                        :formData="data"
                        valuePath="state"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
                <form-cell width="half">
                    <text-field
                        :placeholder="$t('pages.billing.billing.billing_form.zip')"
                        :isRequired="false"
                        :formData="data"
                        valuePath="zip"
                        @change="change($event)"
                    ></text-field>
                </form-cell>
            </form-row>
            <form-row align="center">
                <common-buttons align="center">
                    <common-button
                        :isProcessing="isSending"
                        :label="$t('common.microcopy.continue')"
                        type="primary"
                        @click="triggerStripeSubmit"
                    ></common-button>
                </common-buttons>
            </form-row>
        </form-wrapper>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import StripeComponent from 'components/page-elements/practice/billing/StripeComponent'
    import PracticesAPI from 'api/PracticesAPI'

    export default {
        mixins: [FormMixin],

        components: { StripeComponent },

        props: {
            monthlyPrice: { type: Number, reqired: true, default: null },
            yearlyPrice: { type: Number, reqired: true, default: null },
            isAlreadySubscribed: { type: Boolean, default: false },
            isAnnual: { type: Boolean, default: false },
        },

        data() {
            return {
                isSending: true,
                notificationMessage: '',
            }
        },

        methods: {
            triggerStripeSubmit() {
                this.isSending = true
                this.$refs.stripeComponent.submitPayment()
            },

            paymentDetailsFailed() {
                this.isSending = false
            },

            stripeLoaded() {
                this.isSending = false
            },

            async createSubscription() {
                if (this.isAlreadySubscribed) {
                    this.$emit('billing-address-saved')
                    return
                }
                PracticesAPI.createSubscription({
                    billingAddress: {
                        address: this.data.address,
                        city: this.data.city,
                        state: this.data.state,
                        zip: this.data.zip,
                    },
                    isAnnual: this.isAnnual,
                }).then(() => {
                    this.$emit('billing-address-saved')
                })
            },
        },

        mounted() {
            this.data.address = this.$auth.getPractice().address
            this.data.city = this.$auth.getPractice().city
            this.data.state = this.$auth.getPractice().state
            this.data.zip = this.$auth.getPractice().zip
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';

    .billing-form {
        .billing-form-type {
            display: flex;
            align-items: center;
            font-size: 14px;

            .form-field {
                margin: 0 10px;
            }
        }

        .billing-form--info {
            span {
                font-weight: 600;
                color: $color-black;
            }
        }
    }
</style>
